window.initPayoutXLSXExportForm = function(){
  $('[name="columns[]"]').on('change', function(){
    console.log($('[name="columns[]"]:checked').length);
    $('#submit').prop('disabled', $('[name="columns[]"]:checked').length < 1)
  })
}